import { batch } from 'react-redux';
import { normalize } from './normalize';
import { searchClosest } from './search';

/*
    TODO: errors / namings / fetching

    Может быть разделить данные на две модели?
*/

/*
    https://redux.js.org/usage/structuring-reducers/normalizing-state-shape
*/

const depthMapping = {
    absolute: 'z',
    relative: 'md',
};

const depthRel = {
    absolute: 'relative',
    relative: 'absolute',
};

const initialState = {
    depth: {
        relative: 0,
        absolute: 0,
    },
    queue: [],
    activeDetailIdx: null,
};

export const inclinometryModal = {
    state: initialState,
    reducers: {
        setActiveDetailIdx(state, idx) {
            return { ...state, activeDetailIdx: idx };
        },
        /*
            Устанавливаем всегда два значения сразу, чтобы синхронизировать
            пользовательское значение с значениями из списка.
        */
        setDepthValues(state, values = {}) {
            return { ...state, depth: values };
        },
        updateQueue(state, id) {
            const isNew = !state.queue.includes(id);
            const updatedQueue = isNew ? [...state.queue, id] : state.queue.filter(qId => qId !== id);

            return {
                ...state,
                queue: updatedQueue,
            };
        },
        removeFromQueue(state, id) {
            if (!state.queue.includes(id)) {
                return state;
            }

            return {
                ...state,
                queue: state.queue.filter(qId => qId !== id),
            };
        },
        reset() {
            return initialState;
        },
    },
    effects: dispatch => ({
        setActiveVersionIDEffect({ id: versionID, wellId }, rootState) {
            const { inclinometry } = rootState;

            if (inclinometry.activeVersionID === versionID) return;

            batch(() => {
                this.removeFromQueue(versionID);
                this.setActiveDetailIdx(null);
            });

            dispatch.inclinometry.setActiveVersionID(versionID);
            const incData = inclinometry.details[versionID];
            const data = {
                rel: incData.md,
                abs: incData.z,
            };
            
            dispatch.inclinometry.setDetailsByWellId({ data, wellId });
        },
        setDepthValuesEffect(payload, rootState) {
            const { inclinometry } = rootState;
            const { details, activeVersionID } = inclinometry;

            if (!activeVersionID) {
                console.warn('versionID is not define');
                return;
            }

            const detail = details[activeVersionID];
            const { type, value, idx } = payload;

            /*
                TODO: detail может вообще не прийти. Стоит ли это обрабатывать здесь?
            */

            /*
                Соотносим наши значения со списками значений, которые приходят с сервера.
            */
            const relatedDepth = depthRel[type];

            const depthValues = depthMapping[type];
            const relatedDepthValues = depthMapping[relatedDepth];

            const index = idx || idx === 0 ? idx : searchClosest(value, detail[depthValues]);

            const result = {
                [type]: detail[depthValues][index],
                [relatedDepth]: detail[relatedDepthValues][index],
            };

            /*
                Обновляем активный index для:
                - перерисовки графиков
                - выделение активной строки в таблице (details)
            */
            this.setActiveDetailIdx(index);

            /*
                Устанавливаем найденные значения для глубины и связанной с ней глубиной,
                что влияет ТОЛЬКО на форму отправки значений глубины
            */
            this.setDepthValues(result);
        },
    }),
    selectors: (slice, createSelector) => ({
        getByIDForTable() {
            return createSelector(
                rootState => rootState.inclinometry.activeVersionID,
                rootState => rootState.inclinometry.details,
                (activeVersionID, details) => {
                    return details[activeVersionID] && normalize.toLeftTable(details[activeVersionID]);
                },
            );
        },
    }),
};
